import React from 'react';
import { motion } from 'framer-motion';
import { Car, CreditCard, Users, ShieldCheck, MapPin, Layers } from 'lucide-react';
export function WhyUs() {
  const reasons = [{
    icon: Car,
    title: 'Stock variado',
    desc: 'SUVs, sedanes, camionetas y más para todos los presupuestos.'
  }, {
    icon: CreditCard,
    title: 'Financiación hasta el 100%',
    desc: 'Sin necesidad de anticipo. Consultá por tu caso particular.'
  }, {
    icon: Users,
    title: 'Atención personalizada',
    desc: 'Te asesoramos en cada paso, sin presión y a tu ritmo.'
  }, {
    icon: ShieldCheck,
    title: 'Transparencia total',
    desc: 'Sin letras chicas ni sorpresas. Todo claro desde el primer momento.'
  }, {
    icon: MapPin,
    title: 'Local propio en CABA',
    desc: 'Vení a conocernos en Parque Patricios. Lunes a sábados de 9 a 19hs.'
  }, {
    icon: Layers,
    title: 'Múltiples servicios',
    desc: 'Compra, venta, alquiler, consignación e inversiones. Todo en un solo lugar.'
  }];
  return <section className="py-32 bg-brand-black relative" data-id="element-535" data-mp="3j9d24p5518sk">
      <div className="max-w-7xl mx-auto px-6" data-id="element-536" data-mp="3j7s7z0mqjrv8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-537" data-mp="3nb7zxjnv141l">
          <h2 className="font-heading text-5xl md:text-6xl text-brand-white" data-id="element-538" data-mp="5ugpxggpv3g7">
            ¿Por qué elegir <span className="text-brand-gold" data-id="element-539" data-mp="aucm4tj69ql7">Flash & Go?</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-540" data-mp="evenph0kaeqc">
          {reasons.map((reason, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#111] border border-brand-gold/20 p-8 rounded-xl hover:border-brand-gold/50 transition-colors" data-id="element-541" data-mp="2cly3j9dcp1rx" data-mpi={i}>
              <div className="w-14 h-14 rounded-full bg-brand-gold/10 flex items-center justify-center mb-6" data-id="element-542" data-mp="3ow8oo2b79u8x">
                <reason.icon className="w-7 h-7 text-brand-gold" data-id="element-543" data-mp="6pud2a0elwdp" />
              </div>
              <h3 className="font-heading text-2xl text-brand-white mb-3" data-id="element-544" data-mp="1rj19tqjtbsu">
                {reason.title}
              </h3>
              <p className="text-brand-white/70 leading-relaxed" data-id="element-545" data-mp="ggf51elko2nn">
                {reason.desc}
              </p>
            </motion.div>)}
        </div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-546" data-mp="pi6acic7a7gz"></div>
    </section>;
}